import axios from '@axios'
import Form from '@/libs/vForm'

export default {
  namespaced: true,
  actions: {
    fetchTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('types', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getCategories(ctx, params) {
      return new Promise((resolve, reject) => {
        axios.get(`form/getCategoriesOptionsBy`, {params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getTypesFilters(ctx) {
      return new Promise((resolve, reject) => {
        axios.get(`getTypesFilters`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`types/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addType(ctx, typeData) {
      return new Promise((resolve, reject) => {
        axios.post('types', typeData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editType(ctx, form) {
      console.log(form)
      return new Promise((resolve, reject) => {
        axios.put(`types/${form.id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteType(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`types/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
